import { insertImageValue} from '/set_pics_functions/set_pic_functions.js';
import { createElement } from "/elements_functions/new_elements.js";
import {  SITE_URL, API_GATEWAY } from "/constants/API_constants.js";

export function createUserProfilePicNameAndUsernameGroup(userInfo) {
    
    const userShortInfoGroup = createElement('div', null, ['usig']);

    const userProfilePic = createElement('img', null, ['usig-profile-pic']);
    
    
    const userNameAndUsername = createElement('div', null, ['usig-name-and-username']);
    const username = createElement('a', null, ['usig-username']);
    
    userShortInfoGroup.append(userProfilePic);
    userShortInfoGroup.append(userNameAndUsername);
    
    if(userInfo.userStatus==='suspended' || userInfo.userStatus==='banned') {
        userProfilePic.src = '/images/icons/profile_account.png';
        console.log("User's avatar: ", userProfilePic.src);
        
        username.innerText = 'This user has been restricted';

        userNameAndUsername.classList.add('user-info-restricted');
    } else {
        
        if(userInfo.profilePic!==null && userInfo.profilePic.picPath!==null) {
            insertImageValue(userProfilePic, userInfo.profilePic.picPath);
        } else {
            userProfilePic.src = '/images/icons/profile_account.png';
        }

        username.innerText = '@'+userInfo.username;
        username.href = SITE_URL + '/user/page/' + userInfo.username;
        
        if(userInfo.accountName!==null) {
            const userAccountName = createElement('a', null, ['usig-account-name']);
            userAccountName.innerText = userInfo.accountName;
            userAccountName.href = SITE_URL + '/user/page/' + userInfo.username;
    
            userNameAndUsername.append(userAccountName);

            userShortInfoGroup.userAccountName = userAccountName;
        }
    }
    userNameAndUsername.append(username);

    userShortInfoGroup.userProfilePic = userProfilePic;
    userShortInfoGroup.userNameAndUsername = userNameAndUsername;
    userShortInfoGroup.username = username;
    

    return userShortInfoGroup;
    
}